import { Component } from '@angular/core';
import { ButtonComponent } from '../button.component';

@Component({
  selector: 'button-search',
  templateUrl: './button-search.component.html',
  styleUrls: ['./button-search.component.scss'],
})
export class ButtonSearchComponent extends ButtonComponent {}
